import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { DropdownButton, Button } from 'react-bootstrap';
import ColorUtil from '../utils/color';

require.ensure([], () => {  
    require('./ColorPicker.less');
});

class ColorPicker extends React.Component {

    constructor(props, context) {
        super(props, context);

        let randomIndex = Math.floor(Math.random()*this.props.palette.length);

        this.state = {
            palette: this.props.palette,
            selectedColor: this.props.defaultColor ? this.props.defaultColor : this.props.palette[randomIndex],
        };
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleSelect = (id) => {
        this.setState({
            selectedColor: this.state.palette[id]
        }, () => {
            this.props.handleColorChange(this.state.palette[id]);
        });
        ReactDOM.findDOMNode(this.refs.dropdown).click();
    }

    // OTHER METHODS

    selectDefault = () => { this.props.handleColorChange(this.state.selectedColor); }

    // RENDER METHOD

    render = () => {
        let selectedPillStyle = {
            backgroundColor: ColorUtil.RGBtoRGBA(this.state.selectedColor, 0.5)
        };

        return (
            <DropdownButton id="colorPickerDropdownButton" ref="dropdown" title="" className="select option" style={selectedPillStyle}>
            {
                this.state.palette.map((color, i) => {
                    let pillStyle = {
                        backgroundColor: ColorUtil.RGBtoRGBA(color, 0.5)
                    };

                    return  (
                        <span id={i} key={i}>
                            <Button  title={this.props.title} className="option" key={i} id={i} onClick={this.handleSelect.bind(this, i)} style={pillStyle}/><br/>
                        </span>
                    );
                })
            }
            </DropdownButton>
        );
    }
}

ColorPicker.propTypes = {
    dateFormat: PropTypes.string,
    defaultColor: PropTypes.string,
    handleColorChange: PropTypes.func,
    onChange: PropTypes.func,
    palette: PropTypes.array,
    placeholderText: PropTypes.string,
    selected: PropTypes.object,
    title: PropTypes.string
};

ColorPicker.defaultProps = {
    palette: ['#AC4142', '#D28445', '#90A959', '#75B5AA', '#6A9FB5', '#AA759F', '#8F5536', '#505050']
};

export default ColorPicker;


/** WEBPACK FOOTER **
 ** ./src/app/components/ColorPicker.js
 **/